function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function getRandomMilliseconds() {
  return Math.floor(Math.random() * 1000);
}

window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check && window.innerWidth < 768;
};

const startShuffle = (item, onComplete) => {
  if (item.getAttribute("is_animation")) {
    return;
  }

  item.setAttribute("is_animation", true);

  shuffleText({
    text: item.textContent,
    fps: item.dataset.fps ?? 60,
    duration: item.dataset.duration ?? 1,
    onUpdate: (output) => (item.textContent = output),
    onComplete: () => {
      item.removeAttribute("is_animation");
      shuffleObserver.unobserve(item);

      if (onComplete) onComplete();
    },
  });
};

const loadPreloader = () => {
  const preloader = document.querySelector(".preloader");

  if (!preloader) {
    return;
  }

  const loadingText = document.getElementById('loading-text')
  loadingText.textContent = "L'ENTROPISTE"

  const preloaderLogo = preloader.querySelector(".logo");
  startShuffle(loadingText, () => {
    preloader.classList.add("hide-element");
  });

  setTimeout(() => {
    preloaderLogo.classList.remove("invisible");
    preloaderLogo.classList.add("slide-top");
  }, 400);
};

const addLoadingAnimation = (buttons) => {
  buttons.forEach((button) => {
    button.disabled = true;
  });
};

const removeLoadingAnimation = (buttons) => {
  buttons.forEach((button) => {
    button.disabled = false;
  });
};

const initShuffleAnimation = () => {
  document.querySelectorAll(".shuffle").forEach((item) => {
    shuffleObserver.observe(item);
  });
};

const openSearch = () => {
  const navbarContainer = document.getElementById("navbar");
  document.querySelectorAll(".megamenu-seciton").forEach((section) => {
    section.classList.add("hidden");
  });

  document.querySelectorAll(".sidebar-section").forEach((section) => {
    section.classList.add("hidden");
  });

  document.querySelector(".mobile-nav-links").classList.add("hidden");
  openNav();

  const searchSection = document.querySelector("#menu-search");
  searchSection.classList.remove("hidden");

  navbarContainer.classList.add("active");

  setTimeout(() => {
    document.querySelector(".search-input").focus();
  }, 400); // should greater than the animation duration
};

let debounceTimeout;

const debounce = (func, delay) => {
  return function (...args) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => func.apply(this, args), delay);
  };
};

const setupSearchListener = () => {
  const searchResult = document.querySelector("#search-result");

  document.querySelector(".search-input")?.addEventListener(
    "input",
    debounce(async (e) => {
      if (e.target.value.length < 3) {
        return;
      }

      const results = await ShopifyApi.suggest(e.target.value);

      // remove all the result
      while (searchResult.firstChild) {
        searchResult.removeChild(searchResult.firstChild);
      }

      // display results
      (results?.resources?.results?.products ?? []).map((product) => {
        if (product.price_max == "0.00") {
          return
        }

        const li = document.createElement("li");
        li.classList.add("title", "h2", "opacity-50");

        const a = document.createElement("a");
        a.href = product.url;
        a.textContent = product.title;

        li.appendChild(a);

        searchResult.appendChild(li);
      });
    }, 100)
  );
};

const setupNavbar = () => {
  let activedNavbarItem = null;
  const languageSwitcher = document.getElementById("desktop-language-switcher");

  const openMegaMenu = (targetId) => {
    let sectionToActive = null;

    document.querySelectorAll(".megamenu-seciton").forEach((section) => {
      if (section.id === targetId) {
        sectionToActive = section;
      } else {
        section.classList.add("hidden");
      }
    });

    if (sectionToActive) {
      sectionToActive.classList.remove("hidden");
      navbarContainer.style.maxHeight =
        sectionToActive.clientHeight + 60 + 64 + "px";
    } else {
      navbarContainer.style.maxHeight = "100vh";
    }

    navbarContainer.classList.add("active");
    languageSwitcher.classList.remove("hidden");
  };

  const closeMegaMenu = () => {
    navbarContainer.style.maxHeight = "60px";
    navbarContainer.classList.remove("active");
    activedNavbarItem?.classList.remove("active");
    languageSwitcher.classList.add("hidden");
  };

  const navLinks = document.querySelectorAll(".nav-links li");

  const mobileNavLinks = document.querySelectorAll(".mobile-nav-links li");

  const navbarContainer = document.getElementById("navbar");
  const sidebar = document.getElementById("sidebar");

  const sidebarBack = document.getElementById("sub-sidebar-back");

  navbarContainer.addEventListener("mouseleave", (e) => {
    closeMegaMenu();
  });

  navLinks.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      if (item.dataset.id) {
        openMegaMenu(item.dataset.id);
        navbarContainer
          .querySelector(".nav-links li.active")
          ?.classList.remove("active");

        item.classList.add("active");
        activedNavbarItem = item;

        return;
      }

      closeMegaMenu();
    });
  });

  const openSubSidebar = (targetId) => {
    document.querySelectorAll(".sidebar-section").forEach((section) => {
      if (section.id === targetId) {
        section.classList.remove("hidden");
      } else {
        section.classList.add("hidden");
      }
    });
  };

  mobileNavLinks.forEach((item) => {
    item.addEventListener("click", () => {
      if (!item.dataset.id) {
        return;
      }

      sidebar.style.maxHeight = "0";
      openSubSidebar(item.dataset.id);
    });
  });

  sidebarBack?.addEventListener("click", () => {
    sidebar.style.maxHeight = "none";
  });
};

document.addEventListener("DOMContentLoaded", () => {
  loadPreloader();

  setupNavbar();

  initShuffleAnimation();

  setupSearchListener();

  document
    .querySelectorAll(".footer-parametres-des-cookies")
    .forEach((item) => {
      item.onclick = () => {
        privacyBanner.showPreferences();

        return false;
      };
    });
});

function openNav() {
  document.getElementById("navbar").style.maxHeight = "100vh";

  const menu = document.getElementById("burguermenu");
  menu.classList.add("opened");
  menu.setAttribute("aria-expanded", "Opened");

  document.getElementById("navbar").classList.add("active");
}

function closeNav() {
  document.getElementById("navbar").style.maxHeight = "60px";

  const menu = document.getElementById("burguermenu");
  menu.classList.remove("opened");
  menu.setAttribute("aria-expanded", "Closed");

  document.getElementById("navbar").classList.remove("active");
}

const toggleNav = () => {
  const menu = document.getElementById("burguermenu");

  if (menu.classList.contains("opened")) {
    closeNav();
  } else {
    document.querySelector(".mobile-nav-links").classList.remove("hidden");
    document.querySelector("#menu-search").classList.add("hidden");
    openNav();
  }
};

const toggleVideo = (videoClass) => {
  const videos = document.querySelectorAll(videoClass);
  if (videos.length === 0) {
    return;
  }

  const playIcon = document.querySelector(".play-icon");
  const pauseIcon = document.querySelector(".pause-icon");

  videos.forEach(video => {
    if (video.paused) {
      video.play();

      playIcon.classList.add("hidden");
      pauseIcon.classList.remove("hidden");
    } else {
      video.pause();

      playIcon.classList.remove("hidden");
      pauseIcon.classList.add("hidden");
    }
  })
};

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      selector: this.querySelector(".language-switcher"),
    };

    if (this.elements.selector) {
      this.elements.selector.addEventListener(
        "change",
        this.onChanged.bind(this)
      );
    }
  }

  onChanged(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.value;
    if (form) form.submit();
  }
}
customElements.define("localization-form", LocalizationForm);

const shuffleObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const item = entry.target;
        if (item.tagName == "A" && item.parentElement.tagName == "LI") {
          item.parentElement.style.height = item.parentElement.clientHeight;
        } else {
          item.style.height = item.clientHeight;
        }
        // entry.target.dispatchEvent(new MouseEvent('mouseenter'))

        startShuffle(item, () => {
          setTimeout(() => {
            if (item.tagName == "A" && item.parentElement.tagName == "LI") {
              item.parentElement.style.removeProperty("height");
            } else {
              item.style.removeProperty("height");
            }
          }, 1000);
        });

        shuffleObserver.unobserve(item); // Optional: Stop observing once shown
      }
    });
  },
  { threshold: 0.1 }
); // Adjust threshold as needed

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('header'); 

  window.addEventListener('scroll', function () {
    if (window.innerWidth < 768) {
      if ((window.innerHeight + window.scrollY - 60) >= document.body.offsetHeight) {
        header.classList.add('reverse')
      } else {
        header.classList.remove('reverse')
      }
    } else {
      header.classList.remove('reverse')
    }
  });

});
